import React from 'react';
import { motion } from 'framer-motion';
import { AppWrap } from '../../wrapper';
import { Scene } from './Scene';
import './Header.css';

// const scaleVariants = {
//   whileInView: {
//     scale: [0, 1],
//     opacity: [0, 1],
//     transition: {
//       duration: 1,
//       ease: 'easeInOut',
//     },
//   },
// };

const Header = () => {
  return (
    <div className='app__header app__flex'>
      <div className='app__header-info'>
        <motion.div
          whileInView={{ x: [-100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
          className='app__header-info-title'
        >
          <h2 className='head-text'>
            Every<span> Web Project</span>
            <br /> Needs<span> Great Developers</span>
          </h2>
        </motion.div>
        <motion.div
          whileInView={{ x: [100, 0], opacity: [0, 1] }}
          transition={{ duration: 0.5 }}
        >
          <a className='app__header-info-btn' href='#work'>
            View Work
          </a>
        </motion.div>
      </div>
      <Scene />

      {/* <motion.div
        variant={scaleVariants}
        whileInView={scaleVariants.whileInView}
        className='app__header-circles'
      >
        {[images.firebase, images.react, images.angular].map(
          (circle, index) => (
            <div className='circle-cmp app__flex' key={`circle-${index}`}>
              <img src={circle} alt='circle' />
            </div>
          )
        )}
      </motion.div> */}
    </div>
  );
};

export default AppWrap(Header, 'home');
